import { action, computed, makeObservable, observable } from 'mobx';
import { bpHistory } from 'global/bpHistory';
import { IStepController } from './iStepController';

export type UploadOption = 'standard-flow' | 'custom-file';

export default class FirstStepController extends IStepController {
  private _uploadOption: UploadOption = 'standard-flow';

  // eslint-disable-next-line class-methods-use-this
  get isValid(): boolean {
    return true; // First step is always valid
  }

  get uploadOption(): UploadOption {
    return this._uploadOption;
  }

  get wantsToUploadCustomFile(): boolean {
    return this._uploadOption === 'custom-file';
  }

  public setUploadOption(value: UploadOption): void {
    this._uploadOption = value;
  }

  public setWantsToUploadCustomFile(value: boolean): void {
    this._uploadOption = value ? 'custom-file' : 'standard-flow';
  }

  completeStep(urlParams: string): void {
    if (this._uploadOption === 'standard-flow') {
      bpHistory.push(`/generate-proposal/${urlParams}`);
    }
  }

  constructor() {
    super();
    makeObservable<FirstStepController, '_uploadOption'>(this, {
      _uploadOption: observable,
      isValid: computed,
      uploadOption: computed,
      wantsToUploadCustomFile: computed,
      setUploadOption: action.bound,
      setWantsToUploadCustomFile: action.bound,
      completeStep: action.bound,
    });
  }
}
